import React from 'react'
import styled from 'styled-components'
import { assignPrefix } from '../../../constants'

type EmphasisProps = {
  position?: string
} & React.ComponentPropsWithoutRef<typeof Wrapper>

export default ({ speakerImgLink, speakerName, position, companyName, companyLink, children }: EmphasisProps) => (
  <Wrapper>
    {children}
    <div className="quoteBy">
      {speakerImgLink && <img alt={speakerName} src={assignPrefix(speakerImgLink)} />}
      <span>
        {speakerName && `${speakerName}${position ? ',' : ''}`} {position}
        {companyName && (
          <>
            {' '}
            at <a href={companyLink}>{companyName}</a>{' '}
          </>
        )}
      </span>
    </div>
  </Wrapper>
)

// Styles
const Wrapper = styled.div`
  margin: 64px;

  p {
    font-style: italic;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    margin-bottom: 0px;
  }

  .quoteBy {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 2rem;
      height: 2rem;
      border-radius: 1rem;
      margin-right: 1rem;
      object-fit: cover;
      flex: 0 0 2rem;
      background-color: ${p => p.theme.primaryLight4};
    }

    span {
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 29px;
      a {
        text-decoration: underline;
        font-size: 18px;
      }
    }
  }
`
